import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { USERAUTH_REALM_ACCESS_BASE_PATH } from '../../../../../features/userauth/realm-access/userauth-realm-access-routing';

export const Route = createFileRoute('/_app/_platform/_context-required/realm-access/_realm-access')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'realm-list',
        label: 'Realm Access',
        to: USERAUTH_REALM_ACCESS_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
